<template>
  <header
    class="fixed top-0 left-0 flex items-center justify-between flex-shrink-0 w-full py-4 navigation z-header viewport-gutter bg-primary color-white"
  >
    <div class="container flex items-center justify-between w-full">
      <div>
        <a v-if="href" :href="href" class="block logo" />
        <router-link
          v-else
          :to="$i18nTo({ name: 'voucherSaleLanding' })"
          class="block logo "
        />
      </div>
      <div class="text-white">
        <router-link
          class="focus:outline-none"
          :class="currentLocale === 'de' && 'font-bold'"
          :to="{ ... $route, params: { ...$route.params, locale: undefined}}"
        >
          DE
        </router-link>

        <router-link
          class="focus:outline-none"
          :class="currentLocale === 'en' && 'font-bold'"
          :to="{ ... $route, params: { ...$route.params, locale: 'en'}}"
        >
          EN
        </router-link>
      </div>
    </div>
  </header>
</template>

<script>
import Header from '~brand-components/base/shared/header'

export default Header.extend()
</script>

<style lang="scss" scoped>
.navigation {
  height: 60px;
}

.pdf-include {
  background: url("../../../images/lufthansa/hero/white_pixel.jpg");
}

.logo {
  height: 40px;
  background: url("../../../images/lufthansa/logos/lh_logo_STANDARD_white_rgb.svg");
  background-position: left center;
  background-size: auto 28px;
  background-repeat: no-repeat;
  width: 170px;

  @screen md {
    background-size: auto 38px;
    width: 230px;
  }
}

.mobileNavButton {
  .lines{
    width: 27px;
    height: 14px;
    span {
      top: 0;
      height: 2px;
      &:nth-child(2) {
        top: 6px;
      }
      &:nth-child(3) {
        top: 12px;
      }
    }
  }
  &.active {
    .lines{
      span {
        top: 6px;
        &:first-child {
          @apply transform rotate-135;
          -ms-transform: rotate(135deg);
        }
        &:last-child {
          @apply transform -rotate-135;
          -ms-transform: rotate(-135deg);
        }
        &:nth-child(2) {
          opacity: 0;
        }
      }
    }
  }
}

.mobileNavigation {
  z-index: 49;
  right: 0;
  height: 100%;
}

.langSwitch{
  &:hover{
    .dropdown{
      @apply block;
    }
  }
}

@media screen and (min-width: 768px) {
  .navigation {
    height: 90px;
  }

  .mobileNavButton {
    .lines{
      width: 27px;
      height: 19px;
      span {
        &:nth-child(2) {
          top: 8px;
        }
        &:nth-child(3) {
          top: 17px;
        }
      }
    }
    &.active {
      .lines{
        span {
          top: 9px;
        }
      }
    }
  }
}

@media screen and (min-width: 1280px) {
  .mobileNavigation{
    top: 90px;
    width: 100%;
    height: auto;
    @apply bg-gray-250;
  }
}
</style>
